// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CockpitNotificationPagingResultModel from '../../model/cockpit-notification-paging-result-model';
import CockpitNotificationPagingResultDTO from '../dto/cockpit-notification-paging-result-dto';
import dtoSchema from '../schemas/cockpit-notification-paging-result-schema';
import CockpitNotificationModel from '../../model/cockpit-notification-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class CockpitNotificationPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CockpitNotificationPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => CockpitNotificationModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: CockpitNotificationModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<CockpitNotificationPagingResultDTO>): CockpitNotificationPagingResultModel;
  static toModel(dto: DeepPartial<CockpitNotificationPagingResultDTO> | undefined | null): CockpitNotificationPagingResultModel | undefined;
  static toModel(dto: DeepPartial<CockpitNotificationPagingResultDTO> | undefined | null): CockpitNotificationPagingResultModel | undefined {
    return dto ? new CockpitNotificationPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CockpitNotificationPagingResultModel> | CockpitNotificationPagingResultModel): CockpitNotificationPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as CockpitNotificationPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for CockpitNotificationPagingResultModel, can not map to CockpitNotificationPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
